import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environments } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CsrfBootstrapService {
  private readonly http = inject(HttpClient);
  private token: string | null = null;
  private primePromise: Promise<void> | null = null;

  prime(): Promise<void> {
    if (!this.primePromise) {
      this.primePromise = this.fetchToken().finally(() => {
        this.primePromise = null;
      });
    }

    return this.primePromise;
  }

  ensurePrimed(): Promise<void> {
    if (this.getToken()) {
      return Promise.resolve();
    }

    return this.prime();
  }

  captureToken(response: HttpResponse<unknown>): void {
    const headerToken = response.headers.get('X-XSRF-TOKEN');
    const cookieToken = readCookie('XSRF-TOKEN');
    const token = headerToken ?? cookieToken;

    if (token) {
      this.token = token;
    }
  }

  getToken(): string | null {
    return this.token ?? readCookie('XSRF-TOKEN');
  }

  hasToken(): boolean {
    return this.getToken() !== null;
  }

  private fetchToken(): Promise<void> {
    return firstValueFrom(
      this.http.get(`${environments.apiUrl}auth/ping`, {
        withCredentials: true,
        observe: 'response'
      })
    )
      .then(response => {
        this.captureToken(response);
      })
      .catch(() => undefined);
  }
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}
